// extracted by mini-css-extract-plugin
export default {"ontop":"App_ontop__D-y3A","find":"App_find__2vFoM","logo":"App_logo__ZEVym","body":"App_body__ToEQQ","hide":"App_hide__7JWMv","top":"App_top__0pOXg"};